import { Wording } from '@/types';

export const MEDITATION_WORDING_RO: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditații',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Ghiduri',
  components_header_text2: 'Blog',
  components_header_members: 'Membrii',
  hero_text: 'Unde meditația întâlnește stelele',
  hero_button_text: 'Începe-ți călătoria spre interior',
  components_ressources_section_title: 'RESURSE',
  components_ressources_subheader_text: 'Instrumente pentru pace interioară, împământare și echilibru de zi cu zi',
  components_ressources_span_text: 'Deschideți ușa către pacea interioară cu meditațiile și ghidurile noastre alese cu atenție. Găsiți claritate, reconectați-vă cu respirația și aliniați-vă cu ritmul interior - câte un moment atent.',
  components_ressources_card_1_title: 'Reflecţie',
  components_ressources_card_1_text: 'Scurte meditații și reflecții audio pentru a vă centra gândurile și a vă realini cu ritmul cosmic.',
  components_ressources_card_2_title: 'Explorează adâncurile',
  components_ressources_card_2_text: 'Călătoriți dincolo de suprafață cu ghiduri captivante care îmbină meditația, astrologia și auto-investigația pentru o transformare de durată.',
  components_ressources_link: 'Vezi mai multe',
  components_notes_and_google_title_1: 'Îndrumarea sufletească',
  components_notes_and_google_title_2: 'Ritualuri Mindful',
  components_notes_and_google_title_3: 'Meditații ghidate',
  components_review_google_text: 'Recenzii Google',
  media_content_section_title: 'AUDIO',
  media_content_section_subheader_text: 'Meditațiile noastre',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Descoperiți mai multe',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'GHIDURI',
  components_text1_subheader_text: 'Cunoștințe cosmice pentru alinierea zilnică',
  components_text1_span_text: 'Aliniați-vă cu ritmurile universului: explorați o colecție curată de ghiduri astrologice și meditative aprofundate, concepute pentru a trezi claritatea interioară, a adânci conștiința de sine și a vă sprijini călătoria de creștere sufletească, cerească.',
  components_text1_card_1_title: 'Deschis către liniște',
  components_text1_card_1_text: 'Începeți-vă călătoria cu ghiduri fundamentale de meditație și astrologie - ideal pentru căutătorii atrași de liniștea interioară, modelele cosmice și înțelegerea personală.',
  components_text1_card_3_title: 'Legătura minte-corp',
  components_text1_card_3_text: 'Descoperiți straturile mai profunde ale lumii voastre interioare. Acești ghiduri trec dincolo de suprafață pentru a dezvălui semnificația, emoția și modelele conștiente care vă modelează experiența.',
  components_text1_card_2_title: 'Reflectați și Integrați',
  components_text1_card_2_text: 'De la blocuri emoționale la cicluri planetare - aceste ghiduri oferă instrumente de reflecție, vindecare și transformare prin ritualuri conștiente și înțelepciune astrologică.',
  components_text1_link: 'Vezi toate ghidurile',
  components_footer_text: 'Treziți-vă în interior: liniștea voastră, forța voastră',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Număr de înregistrare',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Termeni și condiții',
  components_footer_privacy: 'Politica de confidențialitate',
  button_load_more: 'Încărcați mai multe',
  page_media_1_content_hero_text: 'Meditații',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Boost de energie',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Ghiduri',
  page_text1_section_title: 'Ghiduri',
  page_text1_subheader_text: 'Ghizii noștri',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Vă rugăm să introduceți adresa dvs. de e-mail pentru a continua',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Intră',
  components_login_success_text: 'Conectare reușită!',
  components_card_link_media_content: 'Ascultă acum',
  components_card_link_text1_content: 'Vizualizați Ghidul',
  components_card_link_text2_content: 'Explora',
  france: 'Franţa',
  cyprus: 'Cipru',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditaţie',
  page_media_content_menu_all: 'Toate',
};